import { Link } from 'react-router-dom';
import { Building } from 'lucide-react';

function TenantBuildouts() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.pexels.com/photos/13068378/pexels-photo-13068378.jpeg?auto=compress&cs=tinysrgb&fit=crop&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Tenant <span className="text-gold">Build Outs</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Complete tenant improvement and build-out services for commercial spaces
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              Whether you're moving into a new retail space, upgrading your office, or opening a new restaurant location, Williams Diversified specializes in tenant improvement and buildout projects that bring your vision to life.
            </p>
            <p>
              Our tenant buildout services cover everything from space planning and design consultation to complete interior construction. We work efficiently to minimize disruption and deliver move-in-ready spaces on schedule and within budget.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>What We Offer</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Complete interior buildouts</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Office space construction</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Retail store fitouts</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Restaurant and hospitality spaces</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Medical and professional offices</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Fast-track construction schedules</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Create Your <span className="text-gold">Perfect Space</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default TenantBuildouts;